import { connect } from 'react-redux';
import { t } from 'i18next';
import React from 'react';
import Login from '../../login/Login';

const LoginPage = ({ session }) => (
  <div>
    <div className="logoContainer">
      <img src="logo.png"
        alt="Ayla Logo"
      />
    </div>
    <div className="loginContainer">
      <div className="loginFormContainer">
        <h1 className="signInTitle">{t('login.title')}</h1>
        <Login session={session} />
      </div>
    </div>
  </div>
);

export default connect()(LoginPage);
